import { Dropdown, Spin } from "antd";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import Button from "../components/button";
import { useLogout } from "../hooks/useAuth"; // ✅ import the hook

import {
  HeaderSearchIcon,
  HomeActiveIcon,
  HomeIcon,
  NotificationSecondaryIcon,
  TicketActiveIcon,
  TicketIcon,
} from "../icons";

import {
  UnitActiveIcon,
  UnitIcon,
  UserIcon,
  UserActiveIcon,
  HeaderIcon,
} from "./Components/icons";
import "./style.scss";
import Avatar from "../components/avatar/index";
import { LogoutOutlined } from "@ant-design/icons";
import { isPermit } from "../utils/permissionCheck";

const AppHeader: React.FC = () => {
  const [loggingOut, setLoggingOut] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const location = useLocation();
  const navigate = useNavigate();
  const logoutMutation = useLogout();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const isHomeActive = location.pathname === "/";
  const isTicketsActive =
    location.pathname.startsWith("/tickets/d/") ||
    location.pathname === "/tickets";

  const isUnitActive = ["/unit", "/unit/d/"].includes(location.pathname);
  const isUserActive = ["/user", "/user-role"].includes(location.pathname);
  const firstName =
    JSON.parse(localStorage.getItem("Data") || "{}")?.data?.member_first_name ||
    "User";
  const email =
    JSON.parse(localStorage.getItem("Data") || "{}")?.data?.member_email_id ||
    "Email";

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const clearCookies = () => {
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });
  };

  const handleLogout = () => {
    setLoggingOut(true);
    const refresh_token = localStorage.getItem("refresh_token");

    logoutMutation.mutate(refresh_token || "", {
      onSuccess: () => {
        clearCookies();
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
      },
      onError: () => {
        clearCookies();
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
      },
    });
  };

  const profileMenu = (
    <>
      <div className="profile-menu">
        <div className="profile-header">
          <Avatar
            // url={UserImage}
            color="#76B0BA"
            name={firstName}
            className="square-avatar"
            size={32}
          />

          <div className="profile-info">
            <div className="profile-name">{firstName || "Unknown User"}</div>

            <div className="profile-email">{email}</div>
          </div>
        </div>

        <div className="profile-divider"></div>

        <div className="logout-item" onClick={handleLogout}>
          <LogoutOutlined />
          {loggingOut ? (
            <>
              <Spin size="small" /> Logging out...
            </>
          ) : (
            "Logout"
          )}
        </div>
      </div>
    </>
  );

  return (
    <header className="header-frame sticky z-99 lg:sticky top-0 flex w-full bg-white  z-200">
      <div className="flex w-full items-center justify-between grow lg:flex-row lg:px-6">
        <div className="flex items-center justify-between gap-2 px-3 py-3   sm:gap-4 lg:justify-normal  lg:px-0 lg:py-4">
          <Link to="/" className="lg:hidden">
            <span className=" max-w-[100px]">
              <HeaderIcon />
            </span>
            {/* <img className=" max-w-[100px]" src={Logo} alt="Logo" /> */}
          </Link>
        </div>

        <div className="header-buttons-frame flex">
          {isPermit(1, "view") && (
            <Button
              iconPosition="start"
              icon={isHomeActive ? <HomeActiveIcon /> : <HomeIcon />}
              className={`transparent header-btn ${
                isHomeActive ? "active" : ""
              }`}
              onClick={() => handleNavigation("/")}
            >
              Home
            </Button>
          )}
          {isPermit(2, "view") && (
            <Button
              iconPosition="start"
              icon={isTicketsActive ? <TicketActiveIcon /> : <TicketIcon />}
              className={`transparent header-btn ${
                isTicketsActive ? "active" : ""
              }`}
              onClick={() => handleNavigation("/tickets")}
            >
              Tickets
            </Button>
          )}
          {isPermit(4, "view") && (
            <Button
              iconPosition="start"
              icon={isUnitActive ? <UnitActiveIcon /> : <UnitIcon />}
              className={`transparent header-btn ${
                isUnitActive ? "active" : ""
              }`}
              onClick={() => handleNavigation("/unit")}
            >
              Unit Group
            </Button>
          )}
          {isPermit(3, "view") && (
            <Button
              iconPosition="start"
              icon={isUserActive ? <UserActiveIcon /> : <UserIcon />}
              className={`transparent header-btn ${
                isUserActive ? "active" : ""
              }`}
              onClick={() => handleNavigation("/user")}
            >
              User Management
            </Button>
          )}
        </div>

        <div className="header-right-frame flex items-center gap-2">
          <Button
            className="transparent header-search"
            icon={<HeaderSearchIcon />}
          />
          <Button
            className="transparent header-notification"
            icon={<NotificationSecondaryIcon />}
          />
          <Dropdown overlay={profileMenu} trigger={["click"]}>
            <span
              className="ant-dropdown-link cursor-pointer "
              onClick={(e) => e.preventDefault()}
            >
              <Avatar
                // url={UserImage}
                color="#76B0BA"
                name={firstName}
                className="square-avatar"
                size={32}
              />
            </span>
          </Dropdown>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
